module.exports = __webpack_public_path__ + "img/noData.1a4b4fa7.png";